import { soloWordDatabaseService } from './soloWordDatabaseService';
import { BOT_CONFIGS } from '../stores/soloStore';

function pickRandom(arr) {
  if (!arr || arr.length === 0) return '';
  return arr[Math.floor(Math.random() * arr.length)];
}

function capitalize(str) {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
}

/**
 * Generates bot answers for the current round.
 *
 * @param {string} letter - Current round letter, e.g. 'A'
 * @param {string[]} categories - e.g. ['name', 'animal', 'place', 'thing']
 * @param {string} botKey - 'kafi' | 'kosi' | 'kemi'
 * @returns {Promise<Object>} - { [category]: string }
 */
export async function generateBotAnswers(letter, categories, botKey) {
  const config = BOT_CONFIGS[botKey];
  if (!config) return Object.fromEntries(categories.map((c) => [c, '']));

  const answers = {};

  for (const category of categories) {
    // Apply answerRate: each bot randomly skips categories based on difficulty
    if (Math.random() > config.answerRate) {
      answers[category] = '';
      continue;
    }

    const words = soloWordDatabaseService.getWordsForLetter(letter, category, config.tier);
    let word = capitalize(pickRandom(words));

    // Validate the word starts with the required letter (guard against bad DB entries)
    if (word && word[0]?.toUpperCase() !== letter.toUpperCase()) {
      word = '';
    }

    answers[category] = word;
  }

  return answers;
}
